export default "__VITE_ASSET__Dk$OE9Sy__"